import {Collapse} from 'antd';
import styled from 'styled-components';

const StyledAccordion = styled(Collapse)`
  font-size: 16px;
  > .ant-collapse-item {
    > .ant-collapse-header {
      padding-left: 0;
      padding-right: 0;
    }
  }
  .ant-collapse-content {
    > .ant-collapse-content-box {
      padding-left: 0;
      padding-right: 0;
    }
  }
  .ant-collapse-arrow {
    color: ${props => props.theme.colors.primary_6} !important;
    font-size: 16px !important;
  }
`;


export {
  StyledAccordion,
}
